import {
  AutoSaveList,
  EMPTY_REFERRAL_VALUES,
  ReferralFields,
  getReferralDeleteMessage,
  mapReferralRowToValues,
  toReferralFieldPayload,
} from '../../../../common';
import { REFERRAL_FORM_SCHEMA } from './validationSchema';
import { TREATMENT_PLAN_V3_DIAGNOSIS_TOOL_OPTIONS } from './constants';
import { getTreatmentPlanV3ReferralRowLabel } from './utils';
import { useFetchTreatmentPlanV3ReferralPage, useTreatmentPlanV3Referrals } from './hooks';
import { TreatmentPlanV3PageContent, TreatmentPlanV3PageLoadState } from '../components';

import type { IReferral, ReferralFormValues, ReferralPayload } from '../../../../common';

export default function ReferralForm() {
  const { retry } = useFetchTreatmentPlanV3ReferralPage();
  const { referrals, isLoading, hasLoaded, hasLoadError, isSaving, create, update, remove } =
    useTreatmentPlanV3Referrals();

  return (
    <TreatmentPlanV3PageContent title="Historical &amp; Current ASD Referrals">
      <TreatmentPlanV3PageLoadState
        errorMessage="Unable to load referrals. Please try again."
        hasLoaded={hasLoaded}
        hasLoadError={hasLoadError}
        onRetry={retry}
      >
        <AutoSaveList<ReferralFormValues, IReferral, ReferralPayload>
          addButtonLabel="Add referral"
          disabled={isLoading}
          emptyValues={EMPTY_REFERRAL_VALUES}
          entries={referrals}
          getDeleteConfirm={(row) => ({
            title: 'Confirm referral deletion?',
            message: getReferralDeleteMessage(row),
          })}
          getRowKey={(row) => row.id}
          getRowLabel={getTreatmentPlanV3ReferralRowLabel}
          isSaving={isSaving}
          listErrorMessage={
            referrals.length === 0 ? 'At least one referral is required' : undefined
          }
          mapRowToValues={mapReferralRowToValues}
          newEntryLabel="New referral"
          onCreate={create}
          onDelete={remove}
          onUpdate={update}
          plainDraft
          renderFields={({ formik, disabled, readOnly, saveField, backgroundColor }) => (
            <ReferralFields
              backgroundColor={backgroundColor}
              diagnosisToolOptions={TREATMENT_PLAN_V3_DIAGNOSIS_TOOL_OPTIONS}
              disabled={disabled}
              formik={formik}
              readOnly={readOnly}
              saveField={saveField}
            />
          )}
          toFieldPayload={toReferralFieldPayload}
          validationSchema={REFERRAL_FORM_SCHEMA}
        />
      </TreatmentPlanV3PageLoadState>
    </TreatmentPlanV3PageContent>
  );
}
